module.exports = __webpack_public_path__ + "img/mate-card_duckduck.1fc52b9.png";